import React, { useMemo } from 'react';
import { ScreenContainer, ContentFrame } from '@pinwheel/origami';
import TemplateForm from '../LinkApiRouter/components/TemplateForm/TemplateForm';
import TitleFrame from '../LinkApiRouter/components/TitleFrame';
import useBankInfo from '../LinkApiRouter/hooks/useBankInfo';
import ModalHeader from '../components/ModalHeader';
import useLinkNavigate from '../hooks/useLinkNavigate';
import useBankInfoInputSubtitle from '../LinkApiRouter/hooks/useBankInfoInputSubtitle';
import useBankInfoInputFields from '../LinkApiRouter/hooks/useBankInfoInputFields';
import { WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING } from '../consts/routing-number-mappings';
import { useAppSelector } from '../state';
import { selectLinkTokenPayload } from '../state/slices/slice-link-params';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
export function BankInfoInputInner(props) {
    var _a = useBankInfo(), bankInfoForm = _a.bankInfoForm, setBankInfoForm = _a.setBankInfoForm;
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    var workspaceName = linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.workspaceName;
    var fieldConfigs = useBankInfoInputFields();
    var routingNumberOverride = useMemo(function () {
        return workspaceName && workspaceName in WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING
            ? WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING[workspaceName]
            : null;
    }, [workspaceName]);
    return (React.createElement(TemplateForm, { onSubmit: function (v) {
            if (routingNumberOverride) {
                v.routingNumber = routingNumberOverride;
            }
            setBankInfoForm(v);
            props.onContinue();
        }, initialValues: bankInfoForm, submitButtonText: "Review", fieldConfigs: fieldConfigs }));
}
var BankInfoInput = function () {
    var navigate = useLinkNavigate();
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    var getLocalizedString = useGetLocalizedString();
    var handleContinue = function (_linkTokenPayload) {
        if (_linkTokenPayload.skipDepositConfirmation) {
            return navigate('/link-api/dds');
        }
        return navigate('/switch-confirmation');
    };
    var subtitle = useBankInfoInputSubtitle();
    return (React.createElement(ScreenContainer, { "data-testid": "bank-info-input" },
        React.createElement(ModalHeader, { showPlatformLogo: true }),
        React.createElement(ContentFrame, null,
            React.createElement(TitleFrame, { title: getLocalizedString('CONFIRM_ACCOUNT_DETAILS'), subtitle: subtitle, "data-testid": "BankInfoInput" },
                React.createElement(BankInfoInputInner, { onContinue: function () { return handleContinue(linkTokenPayload); } })))));
};
export default BankInfoInput;
